<template>
  <v-dialog max-width="400px" v-model="dialog">
    <template v-slot:activator="{ on, attrs }">
      <v-btn small v-bind="attrs" v-on="on" color="red lighten-2" dark>
        Add Card
      </v-btn>
    </template>
    <v-card>
      <v-alert type="error" v-if="message" class="body-2 font-weight-regular">
        {{ message }}
      </v-alert>
      <v-card-text>
        <CollectCard @token="addCard"></CollectCard>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="dialog = false"> Cancel </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" :loading="isLoading" @click="submit">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import settingsService from "@/modules/BackOffice/service.js";
import CollectCard from "@/components/CollectCard.vue"
import EventBus from '@/event-bus.js'

export default {
  props: ['message', 'alert', 'customerId'],
  data() {
    return {
      isLoading: false,
      dialog: false,
      token: null
    };
  },
  components: {
    CollectCard
  },
  methods: {
    submit(){
      EventBus.$emit('get-card');
    },
    async addCard(data) {
      // console.log('this.kldjfd', this.$root)
      // console.log('e', e)
      try {
        this.isLoading = true;
        // const data = await this.pay();
        // const stripeResponse =
        await settingsService.Billing.addCard({ customer: this.customerId, source: data.token.id });
        this.$emit("reloadCard");
        // this.loadCards();
        this.dialog = false;
        this.isLoading = false;
      } catch (error) {
        console.log("error", error);
        this.isLoading = false;
        this.$toast.error(error.data ? error.data.message : "Error", {
          timeout: 2000,
        });
        // this.$toasted.error(error.message, {
        //   position: "top-right",
        //   showHideTransition: "slide",
        //   duration: 3500,
        // });
      }
    },
  },
  
};
</script>

